/**
 * Page placeholder "À venir" — utilisée pour les modules métier listés
 * dans la sidebar (Expédition, Équipes, Statistiques, Abonnement…) qui
 * ne sont pas encore implémentés.
 *
 * Permet d'éviter une page vraiment vide (ni sidebar ni main) quand
 * l'utilisateur clique sur un module futur. La sidebar reste présente
 * (montée par AppShellLayout) et le contenu central explique
 * pourquoi.
 *
 * À supprimer module par module au fur et à mesure que les vraies
 * pages arrivent (V0.5 / V1).
 */

import { Card, Eyebrow } from "@champ-erp/ui";
import { Construction } from "lucide-react";
import { useLocation } from "react-router-dom";

const MODULE_LABELS: Record<string, string> = {
  "/vignoble": "Vignoble",
  "/vendange": "Vendange",
  "/ventes": "Ventes",
  "/expedition": "Expédition",
  "/equipes": "Équipes & planning",
  "/statistiques": "Statistiques",
  "/aide": "Aide",
  "/parametres/abonnement": "Abonnement",
};

function getModuleTitle(pathname: string): string {
  // Match exact d'abord, puis le préfixe le plus long pour gérer les
  // sous-routes type /vignoble/parcelle-12.
  if (MODULE_LABELS[pathname]) return MODULE_LABELS[pathname];
  const prefix = Object.keys(MODULE_LABELS)
    .filter((p) => pathname.startsWith(`${p}/`))
    .sort((a, b) => b.length - a.length)[0];
  return prefix ? MODULE_LABELS[prefix]! : "Module";
}

export function ComingSoonPage() {
  const location = useLocation();
  const moduleName = getModuleTitle(location.pathname);

  return (
    <main className="mx-auto w-full max-w-[1200px] space-y-6 p-4 sm:p-8">
      <div>
        <Eyebrow>{moduleName}</Eyebrow>
        <h1
          className="mt-1.5 font-serif font-semibold tracking-tight text-aubergine-900"
          style={{ fontSize: "34px", letterSpacing: "-0.015em" }}
        >
          {moduleName}
        </h1>
        <p className="mt-2 max-w-2xl text-neutral-600">
          Module en cours de préparation pour la version pilote.
        </p>
      </div>

      <Card className="flex flex-col items-center justify-center gap-4 p-12 text-center">
        <Construction size={48} className="text-champagne-600" />
        <div>
          <p className="text-lg font-medium text-aubergine-900">Bientôt disponible</p>
          <p className="mt-2 max-w-md text-sm text-neutral-600">
            Cette section fait partie de notre feuille de route et sera ouverte progressivement
            après les retours des premiers domaines pilotes.
          </p>
        </div>
      </Card>
    </main>
  );
}
